module.exports = __webpack_public_path__ + "static/media/fleche jaune-essai.3e55a358.svg";